<template>
  <div class="vueComponent" id="VueSignalNoiseRatio">
    <a :href="signalLink" class="plain-link">
      <span :class="signalClass" :title="signalTitle"></span>
    </a>
  </div>
</template>

<script>
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";

export default {
  name: "SignalNoiseRatioIcon",
  mixins: [SonicuCoreMixin],
  props: {
    signalNoiseRatio: {
      type: Number,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    companyId: {
      type: String,
      required: false,
    },
  },
  computed: {
    signalClass: function () {
      return this.signalTextColor + " " + this.signalIcon;
    },
    signalTitle: function () {
      if (this.signalNoiseRatio < -5) {
        return 'Signal to Noise Ratio: Noisy';
      } else if (this.signalNoiseRatio < 0) {
        return 'Signal to Noise Ratio: Okay';
      } else {
        return 'Signal to Noise Ratio: Excellent';
      }
    },
    signalLink: function () {
      return this.company.buildCompanyRoute(`meters/${this.id}`)
    },
    signalTextColor() {
      if (this.signalNoiseRatio < -5 ) {
        return 'text-red-700';
      } else if (this.signalNoiseRatio < 0) {
        return 'text-yellow-400';
      } else {
        return 'text-green-600';
      }
    },
    signalIcon() {
      if (this.signalNoiseRatio < -5) {
        return 'lnr icon-volume-high';
      } else if (this.signalNoiseRatio < 0) {
        return 'lnr icon-volume-medium';
      } else {
        return 'lnr icon-volume-low';
      }
    }
  }
}
</script>

<style scoped>

</style>